import React from 'react';
import Dropzone from 'react-dropzone';
import { ReactSortable } from 'react-sortablejs';
import Preview from './Preview';
import { AddIcon, SettingsIcon } from './Icons';
import { COMPRESS_IMAGE } from '../Common/Constants/ComponentType';
import Loader from './Loader';

const renderComponentAsPerType = (
    handleRotate,
    handleRemove,
    files,
    isGenerating,
    componentType,
    setFiles
) => {    
    switch (componentType) {
        case COMPRESS_IMAGE:            
            return <ReactSortable
                list={files}
                setList={setFiles}
                className="image-thumbnail-grid-itp"
                animation={200}
                ghostClass="sortable-ghost"
            >
                {files.map((file, index) => (
                    <Preview
                        key={index}
                        file={file}
                        handleRotate={handleRotate}
                        handleRemove={handleRemove}
                        isGenerating={isGenerating}
                        componentType={componentType}
                    />
                ))}
            </ReactSortable>
        default:
            return <></>
    }
}


const LeftPane = React.memo(({
    handleFiles,
    fileInputRef,
    setFiles,
    files,
    isGenerating,
    componentType,
    handleRotate,
    handleRemove,
    setIsOptionsVisible
}) => {
    return (<Dropzone onDrop={handleFiles} noClick noKeyboard>
        {({ getRootProps, getInputProps }) => (
            <div {...getRootProps()} className="left-pane-itp">
                <button className="floating-action-btn-itp" onClick={() => fileInputRef.current.click()} title="Add more images" disabled={isGenerating}>
                    <AddIcon />
                </button>
                <button className="settings-toggle-btn-itp" onClick={() => setIsOptionsVisible(true)} title="Show Options">
                    <SettingsIcon />
                </button>
                <input {...getInputProps()} />
                <div className="image-grid-container-itp">
                    {isGenerating && <Loader isGenerating={isGenerating}/>}
                    {
                        renderComponentAsPerType
                            (
                                handleRotate,
                                handleRemove,
                                files,
                                isGenerating,
                                componentType,
                                setFiles
                            )
                    }
                </div>
            </div>
        )}
    </Dropzone>)
}, (prevProps, nextProps) => {
    return (
        prevProps.handleFiles === nextProps.handleFiles &&
        prevProps.fileInputRef === nextProps.fileInputRef &&
        prevProps.setIsOptionsVisible === nextProps.setIsOptionsVisible &&
        prevProps.handleRotate === nextProps.handleRotate &&
        prevProps.handleRemove === nextProps.handleRemove &&
        prevProps.sortableList === nextProps.sortableList &&
        prevProps.setFiles === nextProps.setFiles &&
        prevProps.files === nextProps.files &&
        prevProps.isGenerating === nextProps.isGenerating &&
        prevProps.componentType === nextProps.componentType &&
        prevProps.readFileText === nextProps.readFileText &&
        prevProps.handleDownloadSingle === nextProps.handleDownloadSingle
    );
});
LeftPane.whyDidYouRender = true;
export default LeftPane